import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import { WebPage } from '@grandvision/analytics'
import { DefaultPageProps, DynamicRoutes, getPageSeo } from '@grandvision/bloomreach'
import { Cart, Utils as CartUtils } from '@grandvision/carts'
import { LoaderScreen, SupportFooter } from '@grandvision/common'
import { ReduxPersistGate } from '@grandvision/state'

import componentDefinitions from '../cms/component-definitions'
import Layout from '../components/Layout'

const { publicRuntimeConfig } = getConfig()
const staticsUrl = publicRuntimeConfig.grandvision.staticsUrl
const selfUrl = publicRuntimeConfig.selfUrl || ''
const cmsUrls = publicRuntimeConfig.bloomreach.cmsUrls

function goToCheckout() {
  window.location.assign('/checkout/expedicao')
}

function goToPreviousPage() {
  window.history.back()
}

const getCartItemImageUrl = (item) => CartUtils.getItemImageUrl(staticsUrl, item)

const CartPage = ({
  pageModel,
  asPath,
  preview,
  request,
  productRoutes,
  labels = {},
  store,
}: DefaultPageProps) => {
  if (!pageModel) {
    console.error(`No pageModel found for path: ${asPath}!`)
  }

  const pageLabels = {
    cart: labels.cart || {},
    support: labels.support || {},
    products: labels.products || {},
  }

  const seoData = getPageSeo(pageModel)

  return (
    <CmsPage
      cmsUrls={cmsUrls}
      pageModel={pageModel}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => (
        <Layout
          pageModel={pageModel}
          asPath={asPath}
          isSolaris={true}
          preview={preview}
          renderSiteNav={false}
        >
          <RenderCmsComponent path="main/top-container" />
          <ReduxPersistGate loading={<LoaderScreen />} persistor={store!.persistor!}>
            <DynamicRoutes pageModel={pageModel}>
              {(routeFormatters) => (
                <div className="site-container cart-layout">
                  <Cart
                    getItemImageUrl={getCartItemImageUrl}
                    isDiscountCodeEnabled={true}
                    showCartDiscountDescriptions={true}
                    showCartDiscountOnLineItem={true}
                    showSubTotal={true}
                    showTotalDiscount={true}
                    onPrimaryClick={goToCheckout}
                    onSecondaryClick={goToPreviousPage}
                    productRoutes={productRoutes as []}
                    readOnly={false}
                    deliveryIndicatorConfig={publicRuntimeConfig.grandvision.deliveryIndicator}
                    {...routeFormatters}
                  />
                  <SupportFooter
                    message={pageLabels.support.title}
                    phoneNumber={pageLabels.support.phoneNumber}
                    email={pageLabels.support.emailAddress}
                  />
                </div>
              )}
            </DynamicRoutes>
          </ReduxPersistGate>
          <RenderCmsComponent path="main/bottom-container" />

          <WebPage
            url={selfUrl + asPath}
            pageType={'PurchaseFunnel'}
            name={seoData.title}
            description={seoData.description}
          />
        </Layout>
      )}
    </CmsPage>
  )
}

CartPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, productRoutes, locale, preview } = query as any

  return {
    asPath,
    pageModel,
    preview,
    request,
    productRoutes,
    locale,
  }
}

export default CartPage
